module.exports = __webpack_public_path__ + "img/sjd-banner.72164598.png";